export class SessionStorageKeys {

    static get redirectUrlKey() {
        return 'loginRedirectUrl'
    }
    
    static get surveyTmpSaveKey() {
        return 'surveyTmpSave'
    }

}